import type { Lut } from '@mimir/common/types/lut';
import type { LutMessageFromMain, LutMessageFromWorker, LutRequestFromWorker } from '../protocol/lutProtocol';

export function createLutMainHandler(
  getLuts: () => Promise<Lut[]>,
  postMessageToWorker: (message: LutMessageFromMain, transfer: Transferable[]) => void,
): ((message: LutMessageFromWorker) => void) {
  const handleImageProviderRequest =
    (requestId: number, request: LutRequestFromWorker) => {
      const requestType = request.type;
      switch (requestType) {
        case 'get_luts': {
          getLuts()
            .then((luts) => {
              postMessageToWorker({
                type: 'response',
                requestId,
                response: {
                  type: 'luts',
                  luts,
                }
              }, luts.map((lut) => lut.buffer.buffer));
            })
            .catch((error) => {
              const { message, stack, name } = error;
              postMessageToWorker({
                type: 'response',
                requestId,
                response: {
                  type: 'error',
                  message,
                  stack,
                  name
                }
              }, []);
            });
          break;
        }
        default:
          requestType satisfies never;
      }
    };

  return (message: LutMessageFromWorker): void => {
    const messageType = message.type;
    switch (messageType) {
      case 'request': {
        handleImageProviderRequest(message.requestId, message.request);
        break;
      }
      default:
        messageType satisfies never;
    }
  }
}
